import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AccountConfigurationResponse } from "../models/response/account-configuration-response-input.model";
import { FieldTranslatedResponse } from "../models/response/field-translated-response-input.model";
import { ConfigurationItem } from "../models/interfaces/configuration-item-input.model";
import { ProjectsVisibilityGroupResponse } from "../models/response/projects-visibility-group-response-input.model";
import { ProjectsVisibilityGroupRequest } from "../models/interfaces/projects-visibility-group-request-input.model";
import { UserEmail } from "../models/interfaces/user-email-input.model";
import { ProjectsVisibilityGroupPostBody } from "../models/interfaces/projects-visibility-group-post-body.model";
import { PortalUser } from "../models/interfaces/portal-user-input.model";

@Injectable()
export class AccountConfigurationService {
  connectSettings: string;
  summariesApiUrl: string;
  identitiesApiUri: string;

  constructor(private http: HttpClient) {
    this.connectSettings = environment.apiUris.connectSettings;
    this.summariesApiUrl = environment.apiUris.chartsApiUri;
    this.identitiesApiUri = environment.apiUris.identitiesApiUri;
  }

  getUsersHasAccess(): Observable<boolean> {
    return this.http.get<boolean>(`${this.connectSettings}/Behaviors/Charts/HasAccess`);
  }

  getAccountConfigurations(accountId: string): Observable<AccountConfigurationResponse> {
    return this.http.get<AccountConfigurationResponse>(`${this.connectSettings}/Accounts/${accountId}/AccountConfigurations`);
  }

  getEnumTranslations(cultureName: string, enumName: string): Observable<FieldTranslatedResponse[]> {
    return this.http.get<FieldTranslatedResponse[]>(`${this.connectSettings}/i18n/${cultureName}/Enums/${enumName}`);
  }

  getProjectsVisibilityGroup(accountId: string): Observable<ProjectsVisibilityGroupResponse[]> {
    return this.http.get<ProjectsVisibilityGroupResponse[]>(`${this.connectSettings}/Accounts/${accountId}/ProjectsVisibilityGroup`);
  }

  patchAccountConfigurations(accountId: string, configuritonItem: ConfigurationItem[]) {
    return this.http.patch(`${this.connectSettings}/Accounts/${accountId}/AccountConfigurations`, configuritonItem);
  }

  postAccountConfigurations(accountId: string, projectsVisibilityGroupRequest: ProjectsVisibilityGroupRequest[]) {
    return this.http.post(`${this.connectSettings}/Accounts/${accountId}/AccountConfigurations`, projectsVisibilityGroupRequest);
  }

  postProjectsVisibilityGroup(accountId: string, projectsVisibilityGroupRequest: ProjectsVisibilityGroupPostBody) {
    return this.http.post(`${this.connectSettings}/Accounts/${accountId}/ProjectsVisibilityGroup`, projectsVisibilityGroupRequest);
  }

  getUserByEmailAsync(email: string): Observable<UserEmail> {
    return this.http.get<UserEmail>(`${this.summariesApiUrl}/Query/Users/First?email=${email}`);
  }

  getAccountUsers(accountId: string): Observable<PortalUser[]> {
    return this.http.get<PortalUser[]>(`${this.identitiesApiUri}/Accounts/${accountId}/Users`);
  }

  deleteProjectsVisibilityGroup(accountId: string, id: string) {
    return this.http.delete(`${this.connectSettings}/Accounts/${accountId}/ProjectsVisibilityGroup/${id}`);
  }

  PatchProjectsVisibilityGroup(accountId: string, id: string, projectsVisibilityGroupRequest: ProjectsVisibilityGroupPostBody) {
    return this.http.patch(`${this.connectSettings}/Accounts/${accountId}/ProjectsVisibilityGroup/${id}`, projectsVisibilityGroupRequest);
  }
}
